import * as Yup from 'yup'

export const addStaffSchema = Yup.object().shape({
  staffId: Yup.string()
    .nullable()
    .required('Please select a staff')
    .min(1, 'Please select a staff'),
})
